'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    content: {
      borderStyle: 'solid',
      borderWidth: [[0, 0, 0, 25]],
      outline: 'none',
      width: '100%'
    },
    accept: {
      borderLeftColor: theme.accept
    },
    reject: {
      borderLeftColor: theme.reject
    },
    card: {
      borderTop: theme.cardBorder,
      width: '100%',
      '&:last-child $content': {
        borderBottomLeftRadius: theme.cardBorderRadius
      }
    }
  };
};

var Compare = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Compare, _React$Component);

  function Compare() {
    _classCallCheck(this, Compare);

    return _possibleConstructorReturn(this, (Compare.__proto__ || Object.getPrototypeOf(Compare)).apply(this, arguments));
  }

  _createClass(Compare, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          getInterfaceComp = _props.getInterfaceComp,
          classes = _props.classes;
      var input = content.input,
          accept = content.accept,
          reject = content.reject;
      return _react2["default"].createElement(_react.Fragment, null, input && getInterfaceComp(input, {
        config: config
      }), _react2["default"].createElement('div', {
        className: classes.card
      }, _react2["default"].createElement('div', {
        className: (0, _classnames2["default"])(classes.content, classes.accept)
      }, getInterfaceComp(accept, {
        config: config
      }))), _react2["default"].createElement('div', {
        className: classes.card
      }, _react2["default"].createElement('div', {
        className: (0, _classnames2["default"])(classes.content, classes.reject)
      }, getInterfaceComp(reject, {
        config: config
      }))));
    }
  }]);

  return Compare;
}(_react2["default"].Component), _class2.id = 'compare', _temp)) || _class);
exports["default"] = Compare;